"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
const styles = {
  normas: {
    marginTop: 12,
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    "@media screen and (max-width: 465px)": {
      width: 290
    },
    "@media screen and (max-width: 420px)": {
      width: 235
    }
  },
  itemNormas: {
    "@media screen and (max-width: 398px)": {
      flexGrow: 0,
      maxWidth: '13%',
      flexBasis: '13%'
    }
  },
  itemNormasLabel: {
    marginLeft: 20,
    "@media screen and (max-width: 398px)": {
      marginLeft: 17,
      flexGrow: 0,
      maxWidth: '80%',
      flexBasis: '80%'
    }
  },
  selectNormas: {
    width: 47
  },
  gridGarantias: {
    marginLeft: 30
  },
  widthAReintegrar: {
    width: '90%'
  },
  widthGrantias: {
    width: '90%',
    '& .MuiFormControlLabel-label': {
      "@media screen and (max-width: 430px)": {
        marginTop: 22
      }
    }
  }
};
var _default = styles;
exports.default = _default;